module.exports = __webpack_public_path__ + "img/pic_ai.db4ed032.png";